import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { WhitelabeledComponentKey } from '../../../../../whitelabel/whitelabel-component-types';
import { WhitelabeledComponent } from '../../../../whitelabel/components/whitelabeled-component/whitelabeled-component.component';
import { BaseSidebarStateDirective } from '../sidebar/directives/base-sidebar-state.directive';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';

@Component({
  selector: 'osp-dashboard-layout',
  standalone: true,
  imports: [WhitelabeledComponent, TopbarComponent, AsyncPipe, NgClass, SidebarComponent],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardLayoutComponent {
  @ViewChild('whitelabelRef') whitelabelComponent?: WhitelabeledComponent<WhitelabeledComponentKey>;

  get sidebarState() {
    const instance = this.whitelabelComponent?.componentRef?.instance;
    if (instance instanceof BaseSidebarStateDirective) {
      return instance.state;
    }
    return undefined;
  }

  protected readonly WhitelabeledComponentKey = WhitelabeledComponentKey;
  protected readonly SidebarComponent = SidebarComponent;
}
